export const OAuthBroadCastChannel = 'oauthCallbackBroadcastChannel'
export const OAuthCompletedMessage = 'Oauth Process Completed'
export const OAuthWindowName = 'OauthSessionWindow'
export const OAuthCallBackRoute = '/emoney/oauth/callback'
